<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5858 12L6.34314 16.2426L7.75735 17.6568L12 13.4142L16.2427 17.6569L17.6569 16.2427L13.4142 12L17.6568 7.75735L16.2426 6.34314L12 10.5858L7.75738 6.34318L6.34317 7.75739L10.5858 12Z"
    />
  </svg>
</template>
